import { action, observable, runInAction } from 'mobx';

import { ActivityConnection } from '../clients/activities/GGClient';
import graphqlClient from '../clients/activities/GGClient';
import { ActivityItem } from '../clients/activities/model';

function transformItems(activity: ActivityConnection): ActivityItem[] {
  if (!activity.nodes) {
    return [];
  }

  return activity.nodes.map(item => {
    const { containers, contributors, eventType, object, timestamp } = item;
    return {
      container: containers ? containers.slice(containers.length - 1)[0] : { name: '' },
      contributors: contributors
        ? contributors.map(contributor => {
            const { accountId, name, picture } = contributor.profile;
            return {
              accountID: accountId,
              name,
              picture,
            };
          })
        : [],
      eventType,
      object,
      timestamp,
    };
  });
}

export default class SearchStore {
  @observable hasLoaded: boolean = false;
  @observable isLoading: boolean = false;
  @observable isSearching: boolean = false;

  @observable nodes: ActivityItem[] = [];

  @action
  clearResults() {
    this.nodes = [];
  }

  @action
  enterSearch() {
    this.isSearching = true;
  }

  @action
  exitSearch() {
    this.isSearching = false;
    this.hasLoaded = false;
    this.isLoading = false;
  }

  search(name: string, limit: number): void {
    (async () => {
      try {
        runInAction(() => {
          this.hasLoaded = false;
          this.isLoading = true;
        });

        const search = await graphqlClient.search(name, limit);

        runInAction(() => {
          this.nodes = transformItems(search.data.myActivities.search);
          this.hasLoaded = true;
          this.isLoading = false;
        });
      } catch (e) {
        // tslint:disable-next-line:no-console
        console.error('error when fetching from worklens', e);
      }
    })();
  }
}
